// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActionsWrapper_wrapper__xk7Qh"};